const BILLS_LIST = {
  PAGE_TITLE: 'Bills List | Raychat',

  HEADING_TITLE: 'Bills List',
  HEADING_SUBTITLE:
    'You can view the package type and time, date, invoice status and their details and receive a payment receipt.',

  THERE_IS_NO_BILL: 'There is no bill to display!',

  BILL_ID: 'Bill ID',
  SERVICE_TYPE: 'Service Type',
  DESCRIPTION: 'Description',
  DATE: 'Date',
  AMOUNT: 'Amount',
  STATUS: 'Status',
  OPERATION: 'Operation',

  UNPAID_BADGE: 'Unpaid',
  PAID_BADGE: 'Paid',

  OFFICIAL_BILL_TOOLTIP:
    'Receipt of invoice is only available for paid invoices.',

  NOTF_TITLE: 'Dear Raychat user',
  NOTIF_TEXT:
    'In order to pay your official payment invoice, you need to complete your information first.',

  OFFICIAL_BILL_BTN: 'Official',
  PRE_INVOICE_BTN: 'Pre invoice',

  PACKAGE_PURCHASE_TITLE: 'Online chat platform',
  CONV_CHARGE_PURCHASE_TITLE: 'Conversation charge',

  BILL_DETAILS: 'Details',

  DETAILS_MODAL: {
    TITLE: 'Payment details',
    CODE: 'Payment code',
    PAYMENT_GATEWAY: 'Payment gateway',
    PAYMENT_METHOD: 'Payment method',
    ID: 'Factor ID',
  },

  PAYMENT_AMOUNT_SUFFIX: 'Dollar',

  RECEIPT_FACTOR: {
    TITLE: 'reciept',
    NAME_LABEL: 'Name:',
    PAY_DATE: 'Pay date:',
    FACTOR_NUMBER: 'Factor number:',
    TOTAL_COST: 'Total cost',
    DESCRIPTION: 'Description',
    ROW: 'Row',
    NUM: 'Number',
    EXTRA_CREDIT: 'Conversation extra credit',
    FOOTER: "This receipt is only to confirm the customer's payment",
  },

  OFFICIAL_FACTOR: {
    PACKAGE_PURCHASE_DESC: 'Online chat platform',
    CHARGE_PURCHASE_DESC: 'Online chat platform - Conversation Charge',
    ADDRESS: 'Address: ',
    CURRENCY_SUFFIX: 'Rial: ',
    FACTOR_NUM_LABEL: 'Number',
    FACTOR_REFERENCE: 'Reference',
    PRINT_DATE: 'Print Date',
    PAY_DATE: 'Pay Date',
    INDEX: 'Number',
    RAW_PRICE: 'Price',
    DISCOUNT: 'Discount',
    TAX: 'Tax',
    LOGISTICS: 'Transportation',
    TOTAL_PRICE: 'Total Price',
    SELLER: 'Seller',
    ECONOMIC_NUM: 'Economic number',
    REGISTER_NUM: 'Register number',
    COUNTRY: 'Country',
    STATE: 'State',
    CITY: 'City',
    POSTAL_CODE: 'zip code',
    NATIONAL_ID: 'National Id',
    PHONE: 'Phone',
    BUYER: 'Buyer',
    UNIT_PRICE: 'Unit price',
    UNIT: 'Unit',
    DESC: 'Description',
  },

  BANK_CHOICE_TITLE: 'Select bank',
  CHOOSE_BANK_ERROR: 'Select bank',
  CONTINUE_PURCHASE: 'Continue purchase',
};

export default BILLS_LIST;
